import apiClient from './client'
import publicApiClient from './publicClient'

const likesCommentsService = {
  incrementView:  (postId) => publicApiClient.post(`/posts/${postId}/view`),
  checkLike:      (postId, clientId) => apiClient.get(`/posts/${postId}/like-status`, { params: { client_id: clientId } }).catch(() => ({ isLiked: false })),
  likePost:       (postId, clientId) => apiClient.post(`/posts/${postId}/like`, { client_id: clientId }),
  unlikePost:     (postId, clientId) => apiClient.delete(`/posts/${postId}/like`, { data: { client_id: clientId } }),
  getComments:    (postId) => apiClient.get(`/posts/${postId}/comments`).catch(() => ({ success: false, comments: [] })),
  addComment:     (postId, text, clientId) => apiClient.post(`/posts/${postId}/comments`, { comment_text: text, client_id: clientId }),
  deleteComment:  (postId, commentId) => apiClient.delete(`/posts/${postId}/comments/${commentId}`),
}

export default likesCommentsService
